import { render } from "./PwdUpdateComponent.vue?vue&type=template&id=524d324a&scoped=true&ts=true"
import script from "./PwdUpdateComponent.vue?vue&type=script&lang=ts"
export * from "./PwdUpdateComponent.vue?vue&type=script&lang=ts"

import "./PwdUpdateComponent.vue?vue&type=style&index=0&id=524d324a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524d324a"]])

export default __exports__